module.exports = __webpack_public_path__ + "static/media/linkedin.d492efc7.png";